import { render } from "./DetalleAgendaView.vue?vue&type=template&id=de512f3e&ts=true"
import script from "./DetalleAgendaView.vue?vue&type=script&lang=ts"
export * from "./DetalleAgendaView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__